import { DocumentClaimSection } from './view';
export default DocumentClaimSection;
